@use '@css/variables';

.banner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  padding: 1.5rem;
  background-color: var(--lilac);
  border-radius: var(--border-radius);

  .image {
    flex-shrink: 0;
    width: auto;
    height: 5rem;
  }

  .text {
    flex: 1;
    text-align: center;
  }

  .title {
    margin-bottom: 0.25rem;
  }

  .subtitle {
    margin-bottom: 0;
  }

  .actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.75rem;
  }

  // follows the button's own colour, so it stays visible on hover
  .icon {
    margin-right: 0.75rem;
    color: inherit;
  }
}

@media only screen and (min-width: variables.$md-breakpoint) {
  .banner {
    flex-direction: row;
    gap: 2.5rem;
    padding: 2rem;

    .text {
      text-align: left;
    }
  }
}
